import { Edit, SimpleForm, TextInput } from "react-admin";

export function EditSeo() {
  return (
    <Edit>
      <SimpleForm>
        <TextInput source="slug" fullWidth />
        <TextInput source="title" fullWidth />
        <TextInput source="description" fullWidth multiline />
        <TextInput source="head" fullWidth multiline />
        <TextInput source="body" fullWidth multiline />
      </SimpleForm>
    </Edit>
  );
}
